export const getStyled = (theme) => ({
  maxWidth: {
    width: '100%',
  },
  successButton: {
    backgroundColor: '#4CAF50',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#388e3c',
    },
  },
  errorButton: {
    backgroundColor: '#FF5F1F',
    borderColor: '#FF5F1F',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#ff7139',
      borderColor: '#ff7139',
    },
  },
  dialogPaper: {
    backgroundColor: theme.custom.colors.defaultBackground,
    color: theme.custom.colors.text,

    borderTopColor: theme.custom.colors.text,
    borderBottomColor: theme.custom.colors.text,
  },

  menuItem: {
    backgroundColor: theme.custom.colors.defaultBackground,
    '&:hover': {
      backgroundColor: theme.palette.mode === 'light' ? '#f2f2f2' : '#213445',
    },
    '&.MuiSelected': {
      backgroundColor: theme.palette.mode === 'light' ? '#f2f2f2' : '#294056',
    },
  },

  menuPaper: {
    backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#192734',
  },
});
